import { Box, Switch, Typography } from "@mui/material";
import React from "react";

const WorkerTypeFilter = ({ newShiftSettings, setNewShiftSettings }: any) => {
	if (Object.keys(newShiftSettings).length === 0) return null;
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				padding: "16px",
				marginTop: "32px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Worker Type Filter
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Allows supervisors to restrict individual shifts to specific worker
						types.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newShiftSettings.shiftWorkerTypeFilterEnabled ?? false}
						onChange={(e) =>
							setNewShiftSettings((prevSettings: any) => ({
								...prevSettings,
								shiftWorkerTypeFilterEnabled: e.target.checked,
							}))
						}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default WorkerTypeFilter;
